import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../validators/custom-validators.validators';
import { FormulaireFiserv } from './formulaire-fiserv.model';

export class FormulaireFiservBuilder {
  static build(): FormGroup<FormulaireFiserv> {
    return new FormGroup<FormulaireFiserv>({
      utiliserMemeAdresse: new FormControl<boolean | null>(null, [Validators.required]),
      rue: new FormControl<string | null>('', [
        Validators.required,
        Validators.maxLength(30),
        CustomValidators.texteNonBlanc,
        CustomValidators.caracteresValidesBackendSeulement,
        CustomValidators.doitAvoirUneSeparation,
      ]),
      appartement: new FormControl<string | null>('', [
        Validators.maxLength(8),
        CustomValidators.caracteresValidesBackendSeulement,
      ]),
      ville: new FormControl<string | null>('', [
        Validators.required,
        Validators.maxLength(25),
        CustomValidators.texteNonBlanc,
        CustomValidators.ville,
      ]),
      province: new FormControl<string | null>('', [Validators.required]),
      codePostal: new FormControl<string | null>('', [
        Validators.required,
        CustomValidators.codePostalCanada,
        CustomValidators.caracteresValidesBackendSeulement,
      ]),
      telephone: new FormControl<string | null>('', [Validators.maxLength(12), CustomValidators.numeroTelephone]),
      courriel: new FormControl<string | null>('', [
        Validators.required,
        Validators.maxLength(50),
        CustomValidators.texteNonBlanc,
        CustomValidators.courrielValide,
      ]),
    });
  }
}
